// removed by extract-text-webpack-plugin
module.exports = {"panel":"_37eiA_2EmQDnS3VceHCE5h","title":"_2OHr3MG9Cyy967Hj7WYC3n","content":"n5ZSM3GYolsepThXsVBR_","projectsHeader":"f7hj4vmCwvkGHq5teuI_c"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectMaterials/ProjectMaterials.scss
// module id = 1368
// module chunks = 1